import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from './api';

const Ctx = createContext({ settings: {}, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const s = await api.settings();
      setSettings(s || {});
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ settings, refresh }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);

// Resolve a settings.logoUrl (which may be a relative /api/uploads/... path) to an absolute URL
export function resolveAsset(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url;
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  if (url.startsWith('/')) return `${backend}${url}`;
  return `${backend}/${url}`;
}
